import React from "react";
import { useEffect, useContext } from "react";
import { AuthContext } from "../Routes/AuthProvider";
import { useNavigate } from "react-router-dom";


const HeaderProfile = () => {
    const { logout, name, userName } = useContext(AuthContext);
    const navigate = useNavigate();
    useEffect(() => {
        if (window.KTMenu) {
            window.KTMenu.init();
        }
        if (window.KTDrawer) {
            window.KTDrawer.init();
        }
        if (window.KTScroll) {
            window.KTScroll.init();
        }
    }, []);

    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = () => window.history.go(1);
    }, []);

    const handleLogout = () => {
        logout();
        navigate("/login", { replace: true });
    };

    return (
        <>
            <div class="d-flex flex-column flex-root">
                <div class="page d-flex flex-row flex-column-fluid">
                    <div id="kt_aside" class="aside overflow-visible pb-5 pt-5 pt-lg-0" data-kt-drawer="true" data-kt-drawer-name="aside" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'80px', '300px': '100px'}" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_aside_mobile_toggle">

                        <div class="aside-menu flex-column-fluid" id="kt_aside_menu">
                            <div class="hover-scroll-y my-2 my-lg-5 scroll-ms" id="kt_aside_menu_wrapper" data-kt-scroll="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer" data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">
                                <div class="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-semibold" id="#kt_aside_menu" data-kt-menu="true">
                                    <div class="menu-item py-2">
                                        <a href="/my-profile/personal-information" className="hrd_dash">
                                            <i class="ki-outline ki-user fs-5x "></i>
                                            <span class="menu-title">Personal Info</span>
                                        </a>
                                    </div>
                                    <div class="menu-item py-2">
                                        <a href="/my-profile/organization-profile" className="hrd_dash">
                                            <i class="fa fa-building fs-5x"></i>
                                            <span class="menu-title">Orgenization</span>
                                        </a>
                                    </div>
                                    {/* <div class="menu-item py-2">
                                        <a href="/my-profile/contact-details" className="hrd_dash">
                                            <i class="fa fa-phone fs-5x"></i>
                                            <span class="menu-title">Contact</span>
                                        </a>
                                    </div> */}
                                    <div class="menu-item py-2">
                                        <a href="/my-profile/documents" className="hrd_dash">
                                            <i class="fa fa-file fs-5x"></i>
                                            <span class="menu-title">Documents</span>
                                        </a>
                                    </div>
                                    {/* <div class="menu-item py-2">
                                        <a href="/my-profile/preferences" className="hrd_dash">
                                            <i class="fa fa-book fs-5x"></i>
                                            <span class="menu-title">Preferences</span>
                                        </a>
                                    </div>
                                    
                                    <div class="menu-item py-2 mb-12">
                                        <a href="/my-profile/reporting-parameters" className="hrd_dash">
                                            <i class="fa fa-bug fs-5x"></i>
                                            <span class="menu-title">Reporting</span>
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                        <div id="kt_header" class="header align-items-stretch">
                            <div class="container-fluid d-flex align-items-stretch justify-content-between">
                                <div class="d-flex align-items-center d-lg-none ms-n1 me-2" title="Show aside menu">
                                    <div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
                                        <i class="ki-outline ki-abstract-14 fs-1"></i>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                                    <a href="/" class="d-lg-none">
                                        <img alt="Logo" src="/assets/images/logo.png" class="h-35px" />
                                    </a>
                                </div>
                                <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                                    <div class="d-flex align-items-stretch" id="kt_header_nav">
                                        <div class="header-menu align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_header_menu_mobile_toggle" data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
                                            <div class="menu menu-rounded menu-column menu-lg-row menu-active-bg menu-state-primary menu-title-gray-700 menu-arrow-gray-500 fw-semibold my-5 my-lg-0 px-2 px-lg-0 align-items-stretch" id="#kt_header_menu" data-kt-menu="true">
                                                <div className="logo_company"><img alt="Logo" className='logo_ch' src='/assets/images/logo.png' /></div>
                                                <div className='Navig_company'>
                                                    <ul className='nav nav_bar navigation'>
                                                        <li>
                                                            <a className='nav_link' href='/flight'>
                                                                <img alt="Logo" src='/assets/images/flight-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/flight.png' className='icon_icon_hide' />
                                                                <p>Flight</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/hotel'>
                                                                <img alt="Logo" src='/assets/images/Hotel-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/Hotel.png' className='icon_icon_hide' />
                                                                <p>Hotel</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/bus'>
                                                                <img alt="Logo" src='/assets/images/Bus-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/Bus.png' className='icon_icon_hide' />
                                                                <p>Bus</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/cabs'>
                                                                <img alt="Logo" src='/assets/images/Cab-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/Cab.png' className='icon_icon_hide' />
                                                                <p>Cabs</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/visa'>
                                                                <img alt="Logo" src='/assets/images/Visa-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/Visa.png' className='icon_icon_hide' />
                                                                <p>Visa</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/forex'>
                                                                <img alt="Logo" src='/assets/images/Forex-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/Forex.png' className='icon_icon_hide' />
                                                                <p>Forex</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/insurance'>
                                                                <img alt="Logo" src='/assets/images/Insurance-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/Insurance.png' className='icon_icon_hide' />
                                                                <p>Insurance</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/rail'>
                                                                <img alt="Logo" src='/assets/images/train-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/train.png' className='icon_icon_hide' />
                                                                <p>Rail</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/dashboard/approval'>
                                                                <p className="numbr">4</p>
                                                                <img alt="Logo" src='/assets/images/approval-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/approval.png' className='icon_icon_hide' />
                                                                <p>Approval</p>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a className='nav_link' href='/Dashboard'>
                                                                <img alt="Logo" src='/assets/images/dashboard-white.png' className='icon_icon' />
                                                                <img alt="Logo" src='/assets/images/dashboard.png' className='icon_icon_hide' />
                                                                <p>Dashboard</p>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-stretch flex-shrink-0">
                                        <div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">

                                            <div class="cursor-pointer symbol symbol-30px symbol-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
                                                <img src="/assets/images/profile.png" alt="pics" />
                                            </div>

                                            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px" data-kt-menu="true">
                                                <div class="menu-item px-3">
                                                    <div class="menu-content d-flex align-items-center px-3">
                                                        <div class="symbol symbol-50px me-5">
                                                            <img alt="Logo" src="/assets/images/profile.png" />
                                                        </div>
                                                        <div class="d-flex flex-column">
                                                            <div class="fw-bold d-flex align-items-center fs-5">{name || "User"}
                                                            </div>
                                                            {/* <a href="/" class="fw-semibold text-muted text-hover-primary fs-7">{userName || "UserName"}</a> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="separator my-2"></div>
                                                <div class="menu-item px-5">
                                                    <a href="/settings/Myprofile" class="menu-link px-5">My Profile</a>
                                                </div>
                                                <div class="menu-item px-5">
                                                    <button class="menu-link px-5" onClick={handleLogout}>Logout</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center d-lg-none ms-2 me-n2" title="Show header menu">
                                            <div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_header_menu_mobile_toggle">
                                                <i class="ki-outline ki-burger-menu-2 fs-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};
export default HeaderProfile;
